import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import logo from "@/assets/lurneax-logo.svg";

export default function MobileSplash() {
  const navigate = useNavigate();
  useEffect(() => {
    let cancelled = false;
    (async () => {
      const { data } = await supabase.auth.getSession();
      if (cancelled) return;
      setTimeout(() => {
        navigate(data.session ? "/app/courses" : "/app/login", { replace: true });
      }, 700);
    })();
    return () => {
      cancelled = true;
    };
  }, [navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#FBEAE0]">
      <style>{`
        @keyframes lx-pop { 0% { transform: scale(0.92); opacity: 0; } 100% { transform: scale(1); opacity: 1; } }
        .lx-pop { animation: lx-pop 480ms cubic-bezier(.2,.8,.2,1) both; }
        @media (prefers-reduced-motion: reduce) { .lx-pop { animation: none; } }
      `}</style>
      <div className="lx-pop flex h-28 w-28 items-center justify-center rounded-3xl bg-white shadow-[0_18px_40px_-12px_rgba(42,24,16,0.18)]">
        <img src={logo} alt="Lurneax" className="h-20 w-20 object-contain" />
      </div>
    </div>
  );
}
